import { isTalkie } from '../utils/env';
export const FM_IMAGE_CDN_PREFIX = isTalkie
  ? 'https://talkie.cdn.minimax.io'
  : 'https://xingyeai-images-cdn.oss-cn-shanghai.aliyuncs.com';

export const FM_TAB = {
  All: 'all',
  Draft: 'draft',
} as const;

export const PRE_GENERATE_CUSTOM_INPUT_MAX_LENGTH = 5000;
export const PRE_GENERATE_SCENE_INPUT_MAX_LENGTH = 200;
export const SCRIPT_EDIT_TOTAL_INPUT_MAX_LENGTH = 10000;
export const SCRIPT_EDIT_PARAGRAPH_INPUT_MAX_LENGTH = isTalkie ? 2000 : 500;
